import React from 'react';
import { motion } from 'framer-motion';
import { PieChart, Users, Download } from 'lucide-react';
export function Slide10CoBrand() {
  return <div className="flex flex-col h-full justify-center max-w-6xl mx-auto w-full" data-id="element-130">
      <motion.h2 className="text-5xl font-bold text-white mb-16 text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} data-id="element-131">
        Co‑Brand Sampling™ <span className="text-[#f472b6]" data-id="element-132">(Physical)</span>
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-133">
        <div className="relative flex justify-center" data-id="element-134">
          {/* Pie Chart Animation */}
          <motion.div className="relative w-80 h-80" initial={{
          rotate: -90,
          opacity: 0
        }} animate={{
          rotate: 0,
          opacity: 1
        }} transition={{
          duration: 1
        }} data-id="element-135">
            <svg viewBox="0 0 100 100" className="w-full h-full" data-id="element-136">
              <path d="M50 50 L50 0 A50 50 0 0 1 93.3 25 Z" fill="#4fd1c5" opacity="0.8" data-id="element-137" />
              <path d="M50 50 L93.3 25 A50 50 0 0 1 93.3 75 Z" fill="#ffd700" opacity="0.8" data-id="element-138" />
              <path d="M50 50 L93.3 75 A50 50 0 0 1 50 100 Z" fill="#f472b6" opacity="0.8" data-id="element-139" />
              <circle cx="50" cy="50" r="30" fill="#0a4d4d" data-id="element-140" />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-141">
              <span className="text-2xl font-bold text-white" data-id="element-142">1/3</span>
            </div>
          </motion.div>
        </div>

        <div className="space-y-8" data-id="element-143">
          {['3 brands activated simultaneously', 'Each brand pays 1/3 of cost', 'Our demo experts perform sampling', 'Builds Finns i Sjön brand', 'App downloads & data generated'].map((text, i) => <motion.div key={i} initial={{
          x: 50,
          opacity: 0
        }} animate={{
          x: 0,
          opacity: 1
        }} transition={{
          delay: i * 0.15
        }} className="flex items-center gap-4 text-xl text-white" data-id="element-144">
              <div className="w-2 h-2 rounded-full bg-[#ffd700]" data-id="element-145" />
              {text}
            </motion.div>)}
        </div>
      </div>
    </div>;
}